<div class="dialog-container">
  <div class="title-bar">
    <div class="title">Welcome to Huddy CompassBuilder!</div>
    <mat-progress-spinner *ngIf="working || isLoading()" class="spinner" color="primary" mode="indeterminate" diameter="21">
    </mat-progress-spinner>
  </div>
  <span class="text">Will you be primarily creating compasses or assigning/monitoring them?</span>
  <div class="options">
    <button class="option" [ngClass]="{selected: creating == true}" [disabled]="isDisabled()" (click)="setCreating(true)">
      <span class="option-text">
        Creating
      </span>
    </button>
    <button class="option" [ngClass]="{selected: creating == false}" [disabled]="isDisabled()" (click)="setCreating(false)">
      <span class="option-text">
        Assigning/monitoring
      </span>
    </button>
  </div>
  <div class="buttons">
    <button mat-button class="text-button" [disabled]="!canSave()" (click)="save()">Continue</button>
  </div>
</div>